/**
 * 記事本文・キャプションの文字数と行数を数える。
 *
 * 報道部の依頼で、入力中に文字数と行数を表示するために使う（出稿データには影響しない）。
 * 行数は「1行12字」として文字数を12で割り、端数は1行に切り上げる。
 */

/** 紙面1行あたりの字数 */
export const CHARS_PER_LINE = 12;

/**
 * 文字数を数える。改行は字数に含めない。
 * 絵文字や一部の漢字（サロゲートペア）も1字として数える。
 */
export const countChars = (text: string | null | undefined): number =>
  Array.from((text ?? '').replace(/\r?\n/g, '')).length;

/** 行数（文字数 ÷ 12 の切り上げ） */
export const countLines = (charCount: number): number =>
  Math.ceil(charCount / CHARS_PER_LINE);

/** 入力欄の下に出す表示（例: 「25字 / 3行」） */
export const formatCharCount = (text: string | null | undefined): string => {
  const chars = countChars(text);
  return `${chars}字 / ${countLines(chars)}行`;
};
